/* Image Stages — switches the active stage (image + badge + caption + active button) */
(function () {
  'use strict';

  function initRoot(root) {
    if (root.dataset.stagesInit === '1') return;
    root.dataset.stagesInit = '1';

    var slides = Array.prototype.slice.call(
      root.querySelectorAll('[data-stages-slide]')
    );
    var buttons = Array.prototype.slice.call(
      root.querySelectorAll('[data-stages-btn]')
    );
    var captions = Array.prototype.slice.call(
      root.querySelectorAll('[data-stages-caption]')
    );

    if (!buttons.length) return;

    function activate(index) {
      slides.forEach(function (slide) {
        var match = slide.getAttribute('data-stages-slide') === String(index);
        slide.classList.toggle('is-active', match);
        if (match) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });

      buttons.forEach(function (btn) {
        var match = btn.getAttribute('data-stages-btn') === String(index);
        btn.classList.toggle('is-active', match);
        btn.setAttribute('aria-selected', match ? 'true' : 'false');
      });

      captions.forEach(function (cap) {
        var match = cap.getAttribute('data-stages-caption') === String(index);
        cap.classList.toggle('is-active', match);
        if (match) {
          cap.removeAttribute('hidden');
        } else {
          cap.setAttribute('hidden', '');
        }
      });
    }

    buttons.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        activate(btn.getAttribute('data-stages-btn'));
      });

      // Keyboard navigation between tabs (arrow keys)
      btn.addEventListener('keydown', function (e) {
        var dir = 0;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') dir = 1;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') dir = -1;
        else return;
        e.preventDefault();
        var next = (i + dir + buttons.length) % buttons.length;
        buttons[next].focus();
        activate(buttons[next].getAttribute('data-stages-btn'));
      });
    });

    // Mouse drag-to-scroll for the buttons row (touch stays native)
    var controls = root.querySelector('[data-stages-controls]');
    if (controls) initDragScroll(controls);

    var initial = root.getAttribute('data-initial') || '1';
    activate(initial);
  }

  // Mouse-only drag-to-scroll for the buttons row.
  // We deliberately use mouse events (not pointer/touch) so touch devices keep
  // 100% native behavior: native swipe-scroll for the carousel and native tap
  // for the buttons. Mouse events never fire from a finger tap, so taps are safe.
  // Suppresses the click that ends a real mouse drag so buttons don't fire.
  function initDragScroll(el) {
    var isDown = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;
    var THRESHOLD = 8; // px before it counts as a drag

    el.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return; // primary button only
      isDown = true;
      moved = false;
      startX = e.clientX;
      startScroll = el.scrollLeft;
    });

    window.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > THRESHOLD) {
        moved = true;
        el.classList.add('is-dragging');
      }
      if (moved) {
        e.preventDefault();
        el.scrollLeft = startScroll - dx;
      }
    });

    window.addEventListener('mouseup', function () {
      if (!isDown) return;
      isDown = false;
      el.classList.remove('is-dragging');
    });

    // Swallow the click that ends a drag (capture phase, before button click)
    el.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.stopPropagation();
          e.preventDefault();
          moved = false;
        }
      },
      true
    );
  }

  function initAll() {
    document
      .querySelectorAll('[data-stages-root]')
      .forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-stages-root]');
    if (root) initRoot(root);
  });
})();
